import TitleVideoLink from './TitleVideoLink'

export default TitleVideoLink
// eslint-disable-next-line import/export
export * from './TitleVideoLink'
